import { isString } from 'underscore';

export function getRequestor(serviceRoot, additionalHeader) {
  return function networkRequestor(uri, requestVerb, headers, body) {
    const url = `${serviceRoot}${uri}`;
    const requestHeader = {
      ...additionalHeader,
      ...headers,
    };

    return fetch(url, {
      method: requestVerb,
      headers: requestHeader,
      body: isString(body) ? body : JSON.stringify(body),
    }).then((response) => {
      if (isString(body)) {
        const reader = response.body.getReader();
        return reader.read().then(({ value }) => {
          const responseString = new TextDecoder().decode(value);
          return responseString;
        });
      }
      if (response.status === 401) {
        const error = {
          status: response.status,
        };
        throw error;
      } else if (response.status === 204) {
        return {};
      }

      // read the JSON response in the body
      return response.json().catch((responseJSONParseError) => {
        // handle JSON parsing error here
        const error = {
          status: response.status,
          responseJSONParseError,
        };
        throw error;
      }).then((responseJSON) => {
        if (!response.ok) {
          // 400/500 error with JSON body
          const error = {
            status: response.status,
            responseJSON,
          };
          throw error;
        }

        // normal response with JSON body
        return responseJSON;
      });
    });
  };
}
